import React from "react";

const Privacy = () => {
  return (
    <>
      <section className="privacy-policy">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Effective Date: December 21, 2025</p>

          <p>
            At <strong>Your Company Name</strong>, we value your privacy and are
            committed to protecting your personal information. This Privacy
            Policy explains how we collect, use, and safeguard the information
            you provide when using our internet services and website.
          </p>

          <h2>1. Information We Collect</h2>
          <p>
            We may collect the following types of information from our customers
            and website users:
          </p>
          <ul>
            <li>
              <strong>Personal Information:</strong> Name, email address, phone
              number, billing details, account information.
            </li>
            <li>
              <strong>Usage Information:</strong> Internet service usage data,
              IP addresses, connection logs, and browsing activity for service
              optimization.
            </li>
            <li>
              <strong>Technical Information:</strong> Device type, browser type,
              and operating system used to access our services.
            </li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect for the following purposes:</p>
          <ul>
            <li>
              To provide and maintain our internet services and customer
              support.
            </li>
            <li>To improve our network, services, and website performance.</li>
            <li>
              To communicate important information, such as service updates,
              billing notifications, and promotional offers.
            </li>
            <li>To ensure compliance with legal and regulatory obligations.</li>
            <li>
              To detect, prevent, and address technical issues, fraud, or
              security threats.
            </li>
          </ul>

          <h2>3. Sharing of Information</h2>
          <p>
            We respect your privacy and will not sell your personal information.
            We may share information under the following circumstances:
          </p>
          <ul>
            <li>
              With service providers or partners who assist in delivering our
              services.
            </li>
            <li>
              To comply with legal obligations, government requests, or
              regulatory requirements.
            </li>
            <li>
              In case of business transfers, mergers, or acquisitions, with
              appropriate safeguards.
            </li>
            <li>
              To protect the rights, safety, or property of our company,
              customers, or others.
            </li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We implement reasonable technical and organizational measures to
            protect your information against unauthorized access, disclosure,
            alteration, or destruction. However, no method of electronic storage
            or transmission over the internet is 100% secure.
          </p>

          <h2>5. Your Rights</h2>
          <p>As a user of our services, you have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you.</li>
            <li>Request correction of inaccurate or incomplete information.</li>
            <li>
              Request deletion of your personal data where legally permitted.
            </li>
            <li>Withdraw consent to data processing, where applicable.</li>
          </ul>

          <h2>6. Cookies and Tracking Technologies</h2>
          <p>
            We may use cookies, web beacons, and similar tracking technologies
            to enhance user experience, analyze website traffic, and optimize
            our services. You may disable cookies through your browser settings,
            but this may affect certain functionality.
          </p>

          <h2>7. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not
            responsible for the privacy practices or content of these websites.
            Please review the privacy policies of any third-party sites you
            visit.
          </p>

          <h2>8. Children’s Privacy</h2>
          <p>
            Our services are not directed toward individuals under the age of
            13. We do not knowingly collect personal information from children.
            If we become aware that we have inadvertently collected information
            from a child, we will take steps to delete it promptly.
          </p>

          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with the revised “Effective Date.” We
            encourage you to review this policy periodically to stay informed
            about how we protect your information.
          </p>

          <h2>10. Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests regarding this
            Privacy Policy, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> support@yourcompany.com
            <br />
            <strong>Phone:</strong> +92-XXX-XXXXXXX
            <br />
            <strong>Address:</strong> Your Company Address, City, Country
          </p>
        </div>
      </section>
    </>
  );
};

export default Privacy;
